import React from "react";
import styled from "styled-components";
import { Typography, Card } from "@plum-xoxo/admin-dsm";
export const CustomCard = styled(Card).attrs()`
  box-shadow: ${(props) => props.theme.shadows["10"]};
  height: fit-content;
`;

const CardWithHeader = (props) => {
  return (
    <CustomCard
      spaceAround="6"
      className="d-flex flex-column flex-wrap mt-16 w-100 p-0"
    >
      {props.headerChild || (
        <Typography.H3
          color="dark"
          shade="c300"
          className="align-items-center d-flex flex-row p-24"
        >
          {props.header}
        </Typography.H3>
      )}
      <div className="w-100">
        <hr className="m-0 p-0" />
      </div>
      <div className="p-24 w-100">{props.body}</div>
    </CustomCard>
  );
};

export default CardWithHeader;
